import { CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ParametroConfiguracaoEntity, ParametroConfiguracaoRestricaoEntity } from '@catalogo/models';
import { CONFIGURACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class ParametroConfiguracaoDataService extends CrudService<ParametroConfiguracaoEntity> {

    protected url: string;

    constructor(
        @Inject(CONFIGURACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.url = `${urlBase}/v1/ParametroConfiguracao`;
    }

    public salvarRestricoes = (parametroConfiguracaoId: string, restricoes: ParametroConfiguracaoRestricaoEntity[]) => this.httpClient.post(`${this.url}/restricoes`, {parametroConfiguracaoId, restricoes});

}
